import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@uw-env/environment';
import { AuthService } from '@uw/core/services/auth.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { PostLoginNavigationComponent } from '../../components/post-login-navigation.component';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';
import { LoginContentContainerComponent } from '../../../../shared/components/login-content-container/login-content-container.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { LanguageSelectorComponent } from '../../../../shared/components/language-selector/language-selector.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    templateUrl: './app-selection.component.html',
    styleUrls: ['./app-selection.component.scss'],
    imports: [LoginContentContainerComponent, ButtonComponent, LanguageSelectorComponent, TranslateModule]
})
export class AppSelectionComponent extends PostLoginNavigationComponent implements OnInit {

  accessToken: string;

  constructor(_authService: AuthService,
    _campaignService: CampaignService,
     customNavigationService: CustomNavigationService,
    _router: Router ) {
    super(_authService, _campaignService, customNavigationService);

    const pageState = _router.getCurrentNavigation()?.extras.state;
    this.accessToken = pageState && pageState.token;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  navigateToAdminSite() {

    let adminSiteURL = environment.adminSiteURL;

    // if (this.accessToken) {
    //   adminSiteURL += '?access=' + this.accessToken + '&lang=' + localStorage.getItem('lang');
    // }
    adminSiteURL +='?access=switch&lang=' + localStorage.getItem('lang');
    window.location.href = adminSiteURL;
  }

  navigateToDonationSite() {
    this.donorLoginSuccess$.next();
  }

}
